var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-wrapper',[_c('heading',{staticClass:"heading",attrs:{"size":"l"}},[_vm._v(" "+_vm._s(_vm.$t('header'))+" ")]),_c('div',{staticClass:"error"},[_c('span',[_vm._v(_vm._s(_vm.$t('expired')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }